<div class="row px-4">
	<div class="col-md-12 p-0 mt-4">
    <ul class="nav nav-tabs ss-nav-tabs" id="myTab" role="tablist">
      <!-- <pre>{{ cust_id }}</pre> -->
      <li class="nav-item">
        <a class="nav-link active ss-nav-link" id="home-tab" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true">Logs</a>
      </li>
      <li class="nav-item">
        <a class="nav-link  ss-nav-link" id="home-tab" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true" routerLink="/projects/{{cust_id}}/files" >Files</a>
      </li>
      <li class="nav-item">
        <a class="nav-link ss-nav-link" id="profile-tab" data-toggle="tab" role="tab" aria-controls="profile" aria-selected="false" routerLink="/projects/{{cust_id}}/designer-proposal" >Designer Proposal</a>
      </li>
      <li class="nav-item">
        <a class="nav-link ss-nav-link" id="contact-tab" data-toggle="tab" role="tab" aria-controls="contact" aria-selected="false" routerLink="/projects/{{cust_id}}/discount-proposal" >Discount Proposal</a>
      </li>
    </ul>
  </div>
</div>


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/customer/logs/logs.component.html